export default {
  label: {
    table: {
      header: {
        text: {
          domain: 'Canal',
          count: 'Total de mensagens ativas',
        },
      },
    },
  },
};
